module.exports = __webpack_public_path__ + "static/media/bg-right-img.c83dc045.jpg";